import { Tooltip, Row } from "antd";
import { useMemo } from "react";
import { useSelector } from "react-redux";

type AutoWithDrawalProps = {
  autoChargeFlag: boolean;
};

export const AutoWithDrawal = ({ autoChargeFlag }: AutoWithDrawalProps) => {
  const metaData = useSelector((state: any) => state.metaData);

  const tooltipStyle: any = useMemo(
    () => ({
      maxWidth: "400px",
    }),
    []
  );

  const title = useMemo(() => {
    return (
      <div>
        <a
          href={`mailto:${metaData.companySupportEmail}`}
          className="underline"
        >
          Contact us
        </a>
        &nbsp;to enable automatic recurring payments, so you never have to worry
        about missing a payment.
      </div>
    );
  }, [metaData.companySupportEmail]);

  return (
    <Row>
      {autoChargeFlag ? (
        <p className="my-0 text-sm w-500 title">
          Auto-withdrawal is <span className="success">ON</span>
        </p>
      ) : (
        <Tooltip placement="bottom" title={title} overlayStyle={tooltipStyle}>
          <p className="my-0 text-sm w-500 title off">Auto-withdrawal is OFF</p>
        </Tooltip>
      )}
    </Row>
  );
};
